import { Component, OnInit } from '@angular/core';
import { MenuBreadCrumb } from 'brainloper-ui';

@Component({
    selector: 'app-indicators-maintenance',
    templateUrl: './indicators-maintenance.component.html',
    styleUrls: ['./indicators-maintenance.component.scss'],
    standalone: false
})
export class IndicatorsMaintenanceComponent implements OnInit {

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Indicadores Mantenimiento",
      current: true
    }
  ]

  constructor(

  ) { }


  async ngOnInit() {
  }
}
